module.exports = __webpack_public_path__ + "static/media/line-red.6853d30c.svg";